// extracted by mini-css-extract-plugin
module.exports = {"diagram":"styles_diagram__yP9rO","section":"styles_section__p_Rbl"};